import React, { useContext, useState } from "react";
import { FilterContext } from "../../context/Filter";
import { fetchfreeServiceDataOnTable } from "./apiInsights";
import Freeservicepopup from "./Freeservicepopup";

const ServiceTable = ({ data = {}, loading }) => {
    const { superArn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;

    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState([]);

    const handleOpenPopup = async () => {
        try {
            const payload = {
                [key]: value,
                Stype: data?.servicing_due || null, // send servicing_due to next API
            };

            const res = await fetchfreeServiceDataOnTable(payload);

            setPopupData(res || []); // store popup table data
            setPopupOpen(true); // open popup
        } catch (error) {
            console.error("❌ Error fetching popup data:", error);
        }
    };

    const handleClosePopup = () => setPopupOpen(false);

    if (loading) return <p className="p-4 text-blue-500">Loading...</p>;
    if (!data || Object.keys(data).length === 0)
        return <p className="p-4 text-gray-500">No data available</p>;

    const tableData = [
        {
            servicing_due: data.servicing_due,
            servicing_due_count: data.servicing_due_count,
        },
    ];

    return (
        <div className="p-4">
            <table className="min-w-full border border-blue-500 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left border-r border-blue-400">
                            Servicing Due
                        </th>
                        <th className="px-4 py-2 text-left">Servicing Due Count</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((item, i) => (
                        <tr
                            key={i}
                            className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}
                        >
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.servicing_due}
                            </td>

                            <td
                                className="px-4 py-2 border-t border-blue-200 text-blue-600 cursor-pointer hover:underline"
                                onClick={handleOpenPopup}
                            >
                                {item.servicing_due_count}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* ✅ Show Popup Conditionally */}
            {popupOpen && (
                <Freeservicepopup
                    onClose={handleClosePopup}
                    popupData={popupData}
                />
            )}
        </div>
    );
};

export default ServiceTable;
